import * as style from './style.css';
import * as shared from '../../styledApplication/style.css';
import classes from '../../framework/framework/tools/classes';

import React = require('react');

interface IProps{
}

interface IState{}

export default class ContextMenu extends React.Component<IProps, IState> {
    render() {
        return (
            <div id={'productContextMenu'} className={classes(style.bar, shared.withShadow) }>
                {this.props.children}
            </div>
        );
    }
}
